export default __webpack_public_path__ + "static/Make-your-dollar-travel-further-ffe53b0d30db85dc325c8c5957b4a97c.jpg";